import React, { useState, useEffect } from 'react'
import { Row, Col, Card } from 'reactstrap'
import EirButton from '../eir-button/EirButton';
import OfferTiles from './OfferTiles';
import GeneralTile from '../general-tile/GeneralTile';
import { isMobile, isTablet, isIE } from "react-device-detect";
import { css } from 'emotion';

const ToggleContent = (props) => {

    const renderContent = (content) => {
        return { __html: content };
    }

    return (
        <div className='toggle-content-main'>
            <Row className={(isIE ? 'IE-Browser' : '')}>
                <Col lg='4' md={(isMobile && !isTablet) ? '12' : '4'} sm='12' xl='4' className='position-relative general-product-tile d-flex align-items-center justify-content-center h-auto p-0 mb-auto mt-2'>
                    <Card className='three_six_card p-0'>
                        <GeneralTile
                            image={props.toggle.productTileImage.path}
                            alt={props.toggle.altText}
                            title={props.toggle.productTileTitle}
                            cta={props.toggle.ProductCTA}
                            id={'offer module product CTA ' + props.id}
                        />
                    </Card>
                    {
                        props.toggle.EirProductRoundel.roundelTitle !== '' &&
                        <div className={css`background-color: ${props.toggle.EirProductRoundel.backgroundColor}` + ' position-absolute flex-column d-flex align-items-center justify-content-center roundel product-roundel ' + ((isMobile && !isTablet) ? 'mobile-product-roundel' : '') + (props.toggle.ProductCTA.type === 'button' ? ' product-button' : props.toggle.ProductCTA.type === 'link' ? ' product-link' : '')} dangerouslySetInnerHTML={renderContent(props.toggle.EirProductRoundel.roundelTitle)}></div>
                    }
                </Col>
                <OfferTiles toggle={props.offerTile} id={props.id} />
            </Row>
            <Row className='d-flex align-items-center justify-content-center'>
                <div className='bottom-cta'>
                    <EirButton databundlecode='offers module bottom cta' ariaLabel={props.toggle.bottomCTA.ariaLabel} {...props.toggle.bottomCTA} />
                </div>
            </Row>
        </div >
    )
}

export default ToggleContent
